<template>
    <el-button-group>
        <el-button
            :type="type === 'block' ? 'primary' : ''"
            @click="clickBtn('block')"
        >
            <font-awesome-icon icon="fa-solid fa-table-cells-large" />
        </el-button>

        <el-button
            :type="type === 'list' ? 'primary' : ''"
            @click="clickBtn('list')"
        >
            <font-awesome-icon icon="fa-solid fa-list" />
        </el-button>
    </el-button-group>
</template>

<script setup>

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faList, faTableCellsLarge} from '@fortawesome/free-solid-svg-icons'

const props = defineProps(["type"])
const emits = defineEmits(["clickBtn"])

library.add(faList, faTableCellsLarge)

function clickBtn(name){
    emits("clickBtn", name)
}

</script>

<style scoped>

</style>